module.exports = __webpack_public_path__ + "static/img/Markbj-Cbaj2YBu.0bb3810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/Markbj-Cbaj2YBu.png
// module id = G9hh
// module chunks = 16